import { useUserStore } from '@/store/user'
import { useAuthService } from '@/utils/auth'
import { showErrorToastGlobal } from '@/utils/toast'
import type { RouteLocationNormalized } from 'vue-router'

export const isAuth = async (to: RouteLocationNormalized) => {
  const publicPages = ['qr-menu', 'cart', 'qr-menu-auth', 'tab-link', 'qr-generate', 'instructions', 'new']
  const layout = (to.meta?.layout as string | undefined) || ''
  const path = (to.path || to.fullPath || '') as string
  const isClient = layout === 'Client' || layout === 'ClientEmpty' || path.startsWith('/qr-menu')
  const userStore = useUserStore()

  // Полностью пропускаем админ-аутентификацию для клиентских (qr-menu) маршрутов
  if (isClient) return true

  if (publicPages.includes(to.name?.toString() || '')) {
    return true
  }

  const guestPages = ['login', 'registration', 'oauth-success', 'oauth-error', 'forgot-password', 'qr-menu-auth', 'auth']

  const isGuestPage = guestPages.includes(to.name?.toString() || '')
  const authService = useAuthService()
  const rahmatToken = authService.getRahmatToken()

  const dropSession = () => {
    authService.removeToken()
    userStore.resetUser()
    return isGuestPage ? true : { name: 'login' }
  }

  if (!rahmatToken) {
    if (isGuestPage) return true
    return { name: 'login' }
  }

  // ПРИОРИТЕТ у rahmatToken (email flow)
  const res = await userStore.ensureUser()

  if (res.ok) {
    if (res.user.status === 0) {
      showErrorToastGlobal('Доступ запрещён', 'Аккаунт неактивен')
      return dropSession()
    }
    return isGuestPage ? { name: 'stores' } : true
  }

  if (res.unauthorized) return dropSession()

  // Ошибка сервера или сети — токен при этом валиден, сессию не сбрасываем
  return true
}
